import React from 'react';
import PropTypes from 'prop-types';

const Header = ({ styles }) => (
  <div className={styles['profile-header__wrapper']}>
    <div className={styles['profile-header__header']}>Profil</div>
    <div className={styles['profile-header__description']}>
      <p>
        Hier kannst du deine Profildaten ändern. Du kannst eine neue Adresse
        hinterlegen, wenn du umgezogen bist. Und du kannst uns weitere
        Kontaktdaten zur Verfügung stellen, wenn du lieber digital mit uns
        kommunizieren möchtest.
      </p>
      <p>
        Übrigens: Da wir sichergehen möchten, dass wir deine Daten richtig
        erfassen, gleichen wir sie gegen öffentliche Register ab. Wenn deine
        Angaben nicht zu öffentlichen Registern passen, werden wir die Daten
        nicht übernehmen. In dem Fall melde dich bitte telefonisch bei uns.
      </p>
    </div>
  </div>
);

Header.propTypes = {
  styles: PropTypes.object
};

export default Header;
